import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ContentArrowPosition } from './content-arrow-position';
import { NewLineToHtml, SafeHTML } from '@common/pipes';

@Component({
  selector: 'app-bubble-content',
  templateUrl: './bubble-content.component.html',
  styleUrls: ['./bubble-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NewLineToHtml, SafeHTML],
})
export class BubbleContentComponent {
  readonly content = input('');
  readonly position = input(ContentArrowPosition.TOP_CENTER);
  readonly customArrowLeft = input<undefined | number>(undefined);
}
